
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sit_tier_detail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tier_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tiertype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facture"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sit_tier_detail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tier_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tier_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tiertype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tiertype"}}},{"kind":"Argument","name":{"kind":"Name","value":"facture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facture"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_debut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_fin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodoc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"debit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_opr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ttc_paye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doc_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modepaiement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"situation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reste"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cloture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"docid"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":457}};
    doc.loc.source = {"body":"query sit_tier_detail(\r\n  $tier_id: ID\r\n  $tiertype: ID\r\n  $facture: [ID]\r\n  $date_debut: String\r\n  $date_fin: String\r\n) {\r\n  sit_tier_detail(\r\n    tier_id: $tier_id\r\n    tiertype: $tiertype\r\n    facture: $facture\r\n    date_debut: $date_debut\r\n    date_fin: $date_fin\r\n  ) {\r\n    id\r\n    nodoc\r\n    debit\r\n    date_opr\r\n    credit\r\n    ttc_paye\r\n    statut\r\n    doc_type\r\n    modepaiement\r\n    opr\r\n    situation\r\n    reste\r\n    cloture\r\n    docid\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["sit_tier_detail"] = oneQuery(doc, "sit_tier_detail");
        
